<nav class="w-full h-full flex flex-column" style="background: #F0F2F5">
  <div class="drawer-header flex align-items-center p-3">
    <img
      class="logo-image"
      src="/images/header_logo.svg"
      alt="Full Scale Solutions"
    />
  </div>

  <div class="p-3">
    @for (item of menuItems(); track item.route) {
      <a [routerLink]="item.route"
         routerLinkActive="active"
         #rla="routerLinkActive"
         (mouseenter)="hoveredRoute = item.route"
         (mouseleave)="hoveredRoute = null"
         (click)="onMenuItemClick()"
         class="flex align-items-center py-2 px-3 menu-item">
        <app-dynamic-icon [iconComponent]="item.iconComponent" [stroke]="rla.isActive || hoveredRoute === item.route ? '#181D27' : '#7E838F'"></app-dynamic-icon>
        <span class="text-md-semibold text-gray-700 ml-2">{{ item.label }}</span>
      </a>
    }
  </div>

  <div class="drawer-footer p-3">
    <button type="button" (click)="goToSettings()" class="flex align-items-center py-2 px-3 menu-item w-full">
      <app-settings-01 stroke="#7E838F"></app-settings-01>
      <span class="text-md-semibold text-gray-700 ml-2">Podešavanja</span>
    </button>
    <button type="button" (click)="logout()" class="flex align-items-center py-2 px-3 menu-item w-full">
      <i class="pi pi-sign-out" style="color: #7E838F; font-size: 1rem;"></i>
      <span class="text-md-semibold text-gray-700 ml-2 hover:text-red-600">Odjavi se</span>
    </button>
  </div>
</nav>
